import { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';

const PartnerDoctorWidget = ({ allid = 'sut24076000' }: { allid: string }) => {
    const widgetRef = useRef(null);
    const widgetEnv = process.env.GATSBY_EH_ENV === 'prod' ? '' : `.${process.env.GATSBY_EH_ENV}`;

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (
                typeof window !== 'undefined' &&
                !(widgetRef.current as HTMLElement | null)?.innerHTML
            ) {
                window.dispatchEvent(new Event('load'));
            }
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <div
            id="doctor-widget-wrapper"
            className="border-t-8 border-branded-sutter rounded-md shadow-md bg-surface-light lg:min-w-[691px]"
        >
            <div
                className="ehth-doctor-widget lg:min-w-[691px] lg:min-h-[600px] mx-auto my-0"
                data-alliance-id={allid}
                ref={widgetRef}
            ></div>
            <Helmet>
                <script
                    defer
                    src={`https://widget${widgetEnv}.ehealthinsurance.com/tools/scripts/ehth-widget.js`}
                />
            </Helmet>
        </div>
    );
};

export default PartnerDoctorWidget;
